import React, { useEffect, useState, useCallback } from "react";
import PageTitle from "../../components/pagetitle/PageTitle";
import Footer from "../../components/footer";
import { Button, Select } from "antd";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import "./sells.css";
import { getCurrencies } from "../../services/currencies/currenciesApi";
import {
  addClientVente,
  allMethodes,
} from "../../services/ventes/clientVentesApi";
import { useDropzone } from "react-dropzone";
import { useNavigate } from "react-router-dom";
import { getAllTypeOffers } from "../../services/offers/offersApi";
import countries from "../countries.json";
const { Option } = Select;

export default function Selles() {
  const [codes, setCodes] = useState(["", "", "", ""]);
  const [image, setImage] = useState(null);
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [montant, setMontant] = useState(0);
  const [coins, setCoins] = useState("");
  const [pccurrencie, setPCCurrencie] = useState(null);
  const [consolecurrencie, setConsoleCurrencie] = useState(null);
  const [typeoffers, setTypeOffers] = useState([]);
  const [typeId, setTypeId] = useState(null);
  const [whatsapp, setWhatsapp] = useState("");
  const [country, setCountry] = useState("");

  const [methodes, setMethodes] = useState([]);
  const [methode, setMethode] = useState(null);
  const [compte, setCompte] = useState("");
  const [fileName, setFileName] = useState("");
  const [nom, setNom] = useState("");
  const [prenom, setPrenom] = useState("");
  const [network, setNetwork] =useState("TRC20");
  const [Errors, setErrors] = useState({});
  const navigate = useNavigate();

  const fetchCurrencies = async () => {
    const response = await getCurrencies();
    setConsoleCurrencie(
      response.data.currency_settings.find(
        (currency) => currency.type === "console"
      )
    );
    setPCCurrencie(
      response.data.currency_settings.find((currency) => currency.type === "pc")
    );
  };

  const fetchTypeOffers = async () => {
    try {
      const response = await getAllTypeOffers();
      setTypeOffers(response.data); // Assuming response.data contains the array of type offers
      setTypeId(response.data[0].id);
    } catch (error) {
      toast.error("Failed to fetch type offers"); // Notify error
    }
  };
  useEffect(() => {
    fetchCurrencies();
    fetchTypeOffers();
    const fetchMethodes = async () => {
      const response = await allMethodes();
      setMethodes(response.data);
      console.log("methodes ", response.data);
    };
    fetchMethodes();
  }, []);

  const handleSubmit = () => {
    setErrors({});
    const fields = [
      "login",
      "password",
      "whatsapp",
      "type_id",
      "montant",
      "coins",
      "codes[0]",
      "codes[1]",
      "codes[2]",
      "codes[3]",
      "methode_id",
      "compte",
      "nom",
      "prenom",
      "network",
    ];
    fields.forEach((field) => {
      if (field === "login" && login === "") {
        setErrors((prevErrors) => ({
          ...prevErrors,
          login: t("login is required"),
        }));
      }
      if (field === "password" && password === "") {
        setErrors((prevErrors) => ({
          ...prevErrors,
          password: t("password is required"),
        }));
      }
      if (field === "whatsapp" && whatsapp === "") {
        setErrors((prevErrors) => ({
          ...prevErrors,
          whatsapp: t("whatsapp is required"),
        }));
      }
      if (field === "type_id" && typeId === null) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          type_id: t("type is required"),
        }));
      }
      if (field === "montant" && montant === "") {
        setErrors((prevErrors) => ({
          ...prevErrors,
          montant: t("montant is required"),
        }));
      }
      if (field === "coins" && coins === "") {
        setErrors((prevErrors) => ({
          ...prevErrors,
          coins: t("coins is required"),
        }));
      }
      if (
        (field === "codes[0]" && codes[0] === "") ||
        codes[1] === "" ||
        codes[2] === "" ||
        codes[3] === ""
      ) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          codes: t("codes are required"),
        }));
      }
      if (field === "methode_id" && methode === null) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          methode_id: t("methode is required"),
        }));
      }
      if (field === "compte" && compte === "") {
        setErrors((prevErrors) => ({
          ...prevErrors,
          compte: t("compte is required"),
        }));
      }
      if (field === "network" && methode === 2 && network === "") {
        setErrors((prevErrors) => ({
          ...prevErrors,
          network: t("network is required "),
        }));
      }
    
      if (["7", "8", "9"].includes(methode)) {
        if (field === "nom" && nom === "") {
          setErrors((prevErrors) => ({
            ...prevErrors,
            nom: t("nom is required for this methode"),
          }));
        }
        if (field === "prenom" && prenom === "") {
          setErrors((prevErrors) => ({
            ...prevErrors,
            prenom: t("prenom is required for this methode"),
          }));
        }
      }
    });

    if (Object.keys(Errors).length > 0) {
      return;
    } else {
      const data = new FormData();
      data.append("login", login);
      data.append("password", password);
      data.append("type_id", typeId);
      data.append("montant", montant);
      data.append("coins", coins * 1000);
      data.append("codes[0]", codes[0]);
      data.append("codes[1]", codes[1]);
      data.append("codes[2]", codes[2]);
      data.append("codes[3]", codes[3]);
      data.append("methode_id", methode);
      data.append("whatsapp", whatsapp);
      data.append("image", image);
      data.append("compte", compte);
      data.append("nom", nom);
      data.append("prenom", prenom);
      data.append("network", network);
      addClientVente(data)
        .then((res) => {
          toast.success("Vente ajoutée avec succès");
          navigate(`/successful/${res.data.id}/vente`);
        })
        .catch((err) => {
          toast.error("Erreur lors de l'ajout de la vente");
        });
    }
  };

  const { t } = useTranslation();

  const beforeUpload = (file) => {
    const validTypes = [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "image/gif",
      "image/svg+xml",
    ];
    const isValidType = validTypes.includes(file.type);

    if (!isValidType) {
      toast.error(t("toast.invalidFileType"));
      return false;
    }

    setImage(file);
    setFileName(file.name);
    return false;
  };

  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      beforeUpload(file);
    });
  }, []);

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  const filteredMethodes =
    country !== "Morocco"
      ? methodes.filter((m) => ![3, 4, 5, 6, 7, 8, 9,11].includes(m.id)) // Exclude specific method IDs
      : methodes;

  return (
    <div className="page-about home-1">
      <PageTitle title={t("sells")} />

      <section className="tf-collection-inner">
        <div className="tf-container">
          <div className="row">
            <div className="col-lg-6 mb-3">
              <label htmlFor="login">{t("EA Account/Number")}</label>
              <input
                type="text"
                id="login"
                name="login"
                required
                maxLength="255"
                placeholder={t("EA Account/Number")}
                value={login}
                onChange={(e) => setLogin(e.target.value)}
                className="form-control"
              />
              {Errors.login && (
                <span style={{ color: "red" }}>{Errors.login}</span>
              )}
            </div>
            <div className="col-lg-6 mb-3">
              <label htmlFor="password">{t("EA Password")}</label>
              <input
                type="text"
                id="password"
                name="password"
                required
                maxLength="255"
                placeholder={t("EA Password")}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-control"
              />
              {Errors.password && (
                <span style={{ color: "red" }}>{Errors.password}</span>
              )}
            </div>
            <div className="row">
              <div className="col-lg-6 mb-3">
                <div className="form-group">
                  <label htmlFor="methodes">{t("Type")}</label>
                  <select
                    className="form-control"
                    value={typeId}
                    onChange={(e) => {
                      setTypeId(e.target.value);
                      if (e.target.value == 1 || e.target.value == 2) {
                        const montontK =
                          consolecurrencie?.amount /
                          (consolecurrencie?.coins / 1000);
                        setMontant(coins * montontK);
                      } else {
                        const montontK =
                          pccurrencie?.amount / (pccurrencie?.coins / 1000);
                        setMontant(coins * montontK);
                      }
                    }}
                    placeholder={t("Select Type")}
                    required
                    style={{
                      color: "var(--primary-color2) !important",
                      fontSize: "15px",
                      height: "55px",
                    }}
                  >
                    {typeoffers.map((T) => (
                      <option key={T.id} value={T.id}>
                        {T.nom}
                      </option>
                    ))}
                  </select>
                  {Errors.type_id && (
                    <span style={{ color: "red" }}>{Errors.type_id}</span>
                  )}
                </div>
              </div>
              <div className="col-lg-6 mb-3">
                <label htmlFor="whatsapp">{t("Whatsapp")}</label>
                <input
                  type="text"
                  id="whatsapp"
                  name="whatsapp"
                  required
                  placeholder={t("Whatsapp")}
                  value={whatsapp}
                  onChange={(e) => setWhatsapp(e.target.value)}
                  className="form-control"
                />
                {Errors.whatsapp && (
                  <span style={{ color: "red" }}>{Errors.whatsapp}</span>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6 mb-3">
                <label htmlFor="country">{t("Country")}</label>

                <select
                  value={country}
                  onChange={(e) => setCountry(e.target.value)}
                  placeholder={t("Select Country")}
                  className="form-control"
                  style={{
                    color: "var(--primary-color2) !important",
                    fontSize: "15px",
                    height: "55px",
                  }}
                >
                  <option value="">{t("Select Country")}</option>
                  {countries.map((country) => (
                    <option key={country.code} value={country.name}>
                      {country.name}
                    </option>
                  ))}
                </select>
                {Errors.country && (
                  <span style={{ color: "red" }}>{Errors.country}</span>
                )}
              </div>
            </div>
            <div className="col-lg-6 mb-3">
              <label htmlFor="coins">{t("Coins")}</label>
              <div className="input-group">
                <input
                  type="number"
                  id="coins"
                  name="coins"
                  required
                  maxLength="255"
                  placeholder={t("Coins")}
                  value={coins}
                  onChange={(e) => {
                    if (typeId == 1 || typeId == 2) {
                      const montontK =
                        consolecurrencie?.amount /
                        (consolecurrencie?.coins / 1000);
                      setCoins(e.target.value);
                      setMontant(e.target.value * montontK);
                    } else {
                      const montontK =
                        pccurrencie?.amount / (pccurrencie?.coins / 1000);
                      setCoins(e.target.value);
                      setMontant(e.target.value * montontK);
                    }
                  }}
                  className="form-control"
                />
                <div className="input-group-append">
                  <span className="input-group-text">K</span>
                </div>
              </div>
              {Errors.coins && (
                <span style={{ color: "red" }}>{Errors.coins}</span>
              )}
            </div>
            <div className="col-lg-6 mb-3">
              <label htmlFor="montant">{t("Montant")}</label>
              <div className="input-group">
                <input
                  style={{
                    backgroundColor: "var(--primary-color10) !important",
                  }}
                  type="number"
                  id="montant"
                  name="montant"
                  required
                  placeholder={t("Montant")}
                  value={montant}
                  disabled
                  className="form-control"
                />
                <div className="input-group-append">
                  <span className="input-group-text">USD</span>
                </div>
              </div>
              {Errors.montant && (
                <span style={{ color: "red" }}>{Errors.montant}</span>
              )}
            </div>
            <div className="col-lg-6 mb-3">
              <div className="form-group">
                <label htmlFor="methodes">{t("Methode de paiement")}</label>
                <select
                  className="form-control"
                  value={methode}
                  onChange={(e) => setMethode(e.target.value)}
                  placeholder={t("Select Methode")}
                  required
                  style={{
                    color: "var(--primary-color2) !important",
                    fontSize: "15px",
                    height: "55px",
                  }}
                >
                  <option value="">{t("Select Methode")}</option>
                  {filteredMethodes.map((M) => (
                    <option key={M.id} value={M.id}>
                      {M.nom}
                    </option>
                  ))}
                </select>
              </div>
              {Errors.methode_id && (
                <span style={{ color: "red" }}>{Errors.methode_id}</span>
              )}
              <span style={{ color: "gray", fontSize: "14px" }}>
                {t("fraisdecompte")}
              </span>
            </div>
            {methode && (
              <div className="col-lg-6 mb-3">
                <label htmlFor="compte">
                  {methode == 1
                    ? t("Binance ID")
                    : methode == 2
                      ? t("USDT Address")
                      : methode == 3
                      ? t("Account")
                      :  ["4", "5", "6"].includes(methode)
                        ? t("RIB")
                      :  ["7", "8", "9"].includes(methode)
                        ? t("Identity Card National")
                        : t("Compte")}
                </label>
                <input
                  type="text"
                  id="compte"
                  name="compte"
                  required
                  maxLength="255"
                  placeholder={
                    methode == 1
                      ? t("Binance ID")
                      : methode == 2
                        ? t("USDT Address")
                        :  ["4", "5", "6"].includes(methode)
                        ? t("RIB")
                        :["7", "8", "9"].includes(methode)
                          ? t("Identity Card National")
                          : t("Compte")
                  }
                  value={compte}
                  onChange={(e) => setCompte(e.target.value)}
                  className="form-control"
                />
                {Errors.compte && (
                  <span style={{ color: "red" }}>{Errors.compte}</span>
                )}
              </div>
            )}
            {methode == 2 && (
              <div className="col-lg-6 mb-3">
                <label>{t("Network")}</label>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="network"
                    id="TRC20"
                    value="TRC20"
                    checked={network === "TRC20"}
                    onChange={(e) => setNetwork(e.target.value)}
                  />
                  <label className="form-check-label" htmlFor="TRC20">
                    TRC20
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="network"
                    id="BEP20"
                    value="BEP20"
                    checked={network === "BEP20"}
                    onChange={(e) => setNetwork(e.target.value)}
                  />
                  <label className="form-check-label" htmlFor="BEP20">
                    BEP20
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="network"
                    id="Polygon"
                    value="Polygon"
                    checked={network === "Polygon"}
                    onChange={(e) => setNetwork(e.target.value)}
                  />
                  <label className="form-check-label" htmlFor="Polygon">
                    Polygon
                  </label>
                </div>
                {Errors.network && (
                  <span style={{ color: "red" }}>{Errors.network}</span>
                )}
              </div>
            )}
            {[7, 8, 9].includes(parseInt(methode)) && (
              <>
                <div className="col-lg-6 mb-3">
                  <label htmlFor="nom">{t("nom")}</label>
                  <input
                    type="text"
                    id="nom"
                    name="nom"
                    required
                    maxLength="255"
                    placeholder={t("nom")}
                    value={nom}
                    onChange={(e) => setNom(e.target.value)}
                    className="form-control"
                  />
                  {Errors.nom && (
                    <span style={{ color: "red" }}>{Errors.nom}</span>
                  )}
                </div>

                <div className="col-lg-6 mb-3">
                  <label htmlFor="prenom">{t("prenom")}</label>
                  <input
                    type="text"
                    id="prenom"
                    name="prenom"
                    required
                    maxLength="255"
                    placeholder={t("prenom")}
                    value={prenom}
                    onChange={(e) => setPrenom(e.target.value)}
                    className="form-control"
                  />
                  {Errors.prenom && (
                    <span style={{ color: "red" }}>{Errors.prenom}</span>
                  )}
                </div>
              </>
            )}
            <div className="col-lg-12">
              <label htmlFor="codes">{t("Codes")}</label>
              <div className="row">
                <div className="col-lg-3 mb-3">
                  <input
                    type="text"
                    required
                    placeholder={t("Code")}
                    value={codes[0]}
                    onChange={(e) =>
                      setCodes([e.target.value, codes[1], codes[2], codes[3]])
                    }
                    className="form-control"
                  />
                </div>
                <div className="col-lg-3 mb-3">
                  <input
                    type="text"
                    required
                    placeholder={t("Code")}
                    value={codes[1]}
                    onChange={(e) =>
                      setCodes([codes[0], e.target.value, codes[2], codes[3]])
                    }
                    className="form-control"
                  />
                </div>
                <div className="col-lg-3 mb-3">
                  <input
                    type="text"
                    required
                    placeholder={t("Code")}
                    value={codes[2]}
                    onChange={(e) =>
                      setCodes([codes[0], codes[1], e.target.value, codes[3]])
                    }
                    className="form-control"
                  />
                </div>
                <div className="col-lg-3 mb-3">
                  <input
                    type="text"
                    required
                    placeholder={t("Code")}
                    value={codes[3]}
                    onChange={(e) =>
                      setCodes([codes[0], codes[1], codes[2], e.target.value])
                    }
                    className="form-control"
                  />
                </div>
              </div>
              {Errors.codes && (
                <span style={{ color: "red" }}>{Errors.codes}</span>
              )}
            </div>

            <div className="col-lg-12 mb-3">
              <label htmlFor="image">
                {t("upload image")} {t("Pleaseprovide")}
              </label>
              <div {...getRootProps({ className: "custom-file" })}>
                <input
                  {...getInputProps()}
                  required
                  accept="image/jpeg,image/png,image/jpg,image/gif,image/svg+xml"
                />
                <label className="custom-file-label" htmlFor="image">
                  {fileName || t("Choose file...")}
                </label>
                <div className="upload-zone">
                  <span>
                    {t("Drag & drop your file here or click to upload")}
                  </span>
                </div>
              </div>
              {Errors.image && (
                <span style={{ color: "red" }}>{Errors.image}</span>
              )}
            </div>

            <div className="col-lg-12 mb-3 d-flex justify-content-end">
              <Button onClick={handleSubmit} type="primary">
                {t("Sell")}
              </Button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <ToastContainer draggable />
    </div>
  );
}
